/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */

import type { Sort } from 'stores/PaginationTypes';

export const ENTITY_TABLE_ID = 'field-type';
export const DEFAULT_LAYOUT = {
  pageSize: 20,
  sort: { attributeId: 'index_set_title', direction: 'asc' } as Sort,
  displayedColumns: ['index_set_title', 'stream_titles', 'types'],
  columnsOrder: ['index_set_title', 'stream_titles', 'types'],
};
